import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { UsersService } from 'src/app/Shared/Users/users.service';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';
import { LoginModalComponent } from 'src/app/widgets/login-modal/login-modal.component';
import { SpeechRecognition } from '@capacitor-community/speech-recognition';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-get-user-appoinment',
  templateUrl: './get-user-appoinment.component.html',
  styleUrls: ['./get-user-appoinment.component.css']
})
export class GetUserAppoinmentComponent implements OnInit, OnDestroy, AfterViewInit {

  isLoader: boolean = false;
  appointmentForm!: FormGroup;
  isServiceTabView: boolean = false;
  CategoryList: any[] = [];
  SubCategoryList: any[] = [];
  selectedCategory: string = '';
  categoryServiceType: string = '';
  selectedCatType: string = '';
  isMobileApp: boolean = false;
  isAndroidApk: boolean = false;

  // Voice recording properties
  isVoiceModalOpen: boolean = false;
  voiceTranscript: string = '';
  isMobileRecording: boolean = false;
  isProcessingVoice: boolean = false;
  listeningField: string = '';

  // Mobile: Audio recording
  private mediaRecorder: MediaRecorder | null = null;
  private audioChunks: Blob[] = [];
  private stream: MediaStream | null = null;

  // OpenAI API Key
  private openAiApiKey: string = environment.openAiApiKey;

  // Auth properties
  IsLogin: boolean = false;
  authProfileData: any = null;
  authUserID: number = 0;

  @ViewChild(LoginModalComponent) loginModal!: LoginModalComponent;
  private loginSubscription: any = null;
  private pollInterval: any = null;
  private storageEventHandler: any = null;

  speechRecognitionInitialized: boolean = false;
  hasMicrophonePermission: boolean = false;
  speechRecognitionAvailable: boolean = false;

  private groqApiKey: string = environment.groqApiKey;

  isDesktopBrowser: boolean = false;
  private microphonePermissionRequested: boolean = false;


  // Add these properties to the class
  querySourceType: string = '';
  querySourceMobile: string = '';
  shopId: number | null = null;
  showSourceMobileInput: boolean = false;
  // Add this property
  @ViewChild('sourceMobileInput') sourceMobileInputRef: any;


  homePropertyTypeMap: { [key: string]: string } = {
    '1': 'Residential',
    '1--1': 'Apartment',
    '1--2': 'Independent',
    '1--3': 'Farm House',
    '1--4': 'Villa',
    '1--5': 'Penthouse',
    '1--6': 'Studio House',
    '1--17': 'Car Parking (R)',
    '1--20': 'Rooftop Leasing for Solar',
    '1--21': 'Event Spaces (Short Time)',
    '1--23': 'PG Service/Co-Living',
    '2': 'Commercial',
    '2--7': 'Office Space',
    '2--8': 'Showroom',
    '2--9': 'Shop',
    '2--10': 'IT Park (SEZ)',
    '2--11': 'Warehouse',
    '2--18': 'Co-working Spaces',
    '2--22': 'Car Parking (C)',
    '3': 'Land',
    '3--12': 'Residential',
    '3--13': 'Commercial',
    '3--14': 'Industrial',
    '3--15': 'Agricultural',
    '3--16': 'Farm House',
    '3--19': 'Urban Farming'
  };

  private boundHandleLoginStateChanged: any;

  // Location properties
  locationError: string = '';
  isLocationCaptured: boolean = false;
  capturedLatitude: number | null = null;
  capturedLongitude: number | null = null;
  locationAccuracy: number | null = null;
  isCapturingLocation: boolean = false;
  distanceFromShop: number | null = null;


  // Add this property with other location properties
  isLocationRequired: boolean = true;  // Make location mandatory
  locationRetryCount: number = 0;
  maxLocationRetries: number = 3;



  // Reverse mapping for property type lookup
  propertyTypeReverseMap: { [key: string]: string } = {};

  private capacitorSpeechAvailable: boolean = false;
  private speechResultListener: any = null;

  constructor(
    private fbAppointment: FormBuilder,
    private userAppointmentService: UsersService,
    private appointmentCommonService: CommonService,
    private appointmentPropertyService: PropertyPostsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,  // Add this
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.buildReverseMap();
    this.microphonePermissionRequested = false;
  }

  // Add method to validate mobile number
  isValidMobile(mobile: string): boolean {
    if (!mobile) return false;
    const cleanMobile = mobile.replace(/\D/g, '');
    return cleanMobile.length === 10 && /^[6-9]\d{9}$/.test(cleanMobile);
  }

  // Add this method to handle source mobile input changes
  onSourceMobileInput(event: any): void {
    const value = event.target.value;
    // Remove non-digit characters
    const digits = value.replace(/\D/g, '');
    // Limit to 10 digits
    if (digits.length <= 10) {
      this.querySourceMobile = digits;
    } else {
      this.querySourceMobile = digits.substring(0, 10);
    }
    // Trigger change detection
    this.cdr.detectChanges();
  }

  async ngOnInit(): Promise<void> {

    // Parse query parameters first
    this.parseQueryParams();

    this.isMobileApp = Capacitor.isNativePlatform();
    this.isAndroidApk = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

    this.isDesktopBrowser = !this.isMobileApp && !this.isAndroidApk && this.isDesktopDevice();
    this.microphonePermissionRequested = false;

    // Initialize Capacitor Speech Recognition for Android
    if (this.isAndroidApk) {
      await this.initCapacitorSpeechRecognition();
    } else if (this.isMobileApp) {
      await this.checkSpeechRecognitionAvailability();
    }

    this.appointmentForm = this.fbAppointment.group({
      InteractionType: ['PostRequirement', [Validators.required]],
      Name: ['', [Validators.required]],
      Mobile: ['', [Validators.required, Validators.pattern('^([6-9]{1})([0123456789]{1})([0-9]{8})?$'), Validators.maxLength(11)]],
      Email: [''],
      ReqType: ['', [Validators.required]],
      PropertyType: ['', [Validators.required]],
      PropertySubType: [''],
      Area: ['', [Validators.required]],
      Budget: ['', [Validators.required]],
      // Hidden location fields - make them required for validation
      Latitude: ['', [Validators.required]],
      Longitude: ['', [Validators.required]],
      LocationAccuracy: [''],
      ShopID: ['']
    });

    // Check login status after form initialization
    this.checkLoginStatus();

    // Show login modal immediately if not logged in
    setTimeout(() => {
      this.checkAndShowLoginIfNeeded();
    }, 500);

    // Store the bound function reference
    this.boundHandleLoginStateChanged = this.handleLoginStateChanged.bind(this);
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    // Add localStorage event listener as backup
    this.storageEventHandler = this.handleStorageChange.bind(this);
    window.addEventListener('storage', this.storageEventHandler);
    window.addEventListener('loginStateChanged', this.boundHandleLoginStateChanged);

    // IMPORTANT: Always capture location on page load (for both desktop and mobile)
    // This will ask for permission automatically. Browser only - geolocation can never
    // succeed during SSR, and its retry-on-failure loop would just burn real seconds
    // (setTimeout-spaced retries) for nothing on every server render.
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(async () => {
        await this.captureLocationWithPermission();
      }, 1000);
    }
  }




  // Add method to parse query parameters
  private parseQueryParams(): void {
    this.route.queryParams.subscribe(params => {
      // Get SourceType from query string
      this.querySourceType = params['SourceType'] || 'Shop';

      // For QR and VisitingCard, show input field for referrer mobile
      if (this.querySourceType === 'QR' || this.querySourceType === 'VisitingCard') {
        this.showSourceMobileInput = true;
        // Check if SourceMobile is already provided (optional)
        this.querySourceMobile = params['SourceMobile'] || '';
      } else {
        this.showSourceMobileInput = false;
        this.querySourceMobile = '';
      }

      // Log the source information
      console.log('📊 Source Information:', {
        SourceType: this.querySourceType,
        SourceMobile: this.querySourceMobile,
        showInput: this.showSourceMobileInput
      });
    });
  }

  // Get source display text
  getSourceDisplayText(): string {
    switch (this.querySourceType) {
      case 'QR':
        return '📱 Referred via QR Card';
      case 'VisitingCard':
        return '📇 Referred via Visiting Card';
      default:
        return '🏪 Referred via Shop QR Code';
    }
  }

  // Get source description/instructions
  getSourceInstruction(): string {
    switch (this.querySourceType) {
      case 'QR':
        return 'Please enter the mobile number of the person who referred you via QR Card';
      case 'VisitingCard':
        return 'Please enter the mobile number of the person who gave you the Visiting Card';
      default:
        return '';
    }
  }

  // Get placeholder text for source mobile input
  getSourceMobilePlaceholder(): string {
    switch (this.querySourceType) {
      case 'QR':
        return 'Enter referrer mobile number (QR Card)';
      case 'VisitingCard':
        return 'Enter referrer mobile number (Visiting Card)';
      default:
        return '';
    }
  }


  async captureLocationWithPermission(): Promise<boolean> {
    // Check if geolocation is supported
    if (!navigator.geolocation) {
      this.locationError = 'Geolocation is not supported by your browser';
      this.appointmentCommonService.CallToster('E', this.locationError);
      this.isLocationCaptured = false;
      // Mark location fields as invalid
      this.appointmentForm.controls['Latitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Longitude'].setErrors({ 'required': true });
      // Force form validation update
      this.appointmentForm.updateValueAndValidity();
      this.cdr.detectChanges();
      return false;
    }

    this.isCapturingLocation = true;
    this.locationError = '';
    this.isLocationCaptured = false;

    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0
          }
        );
      });

      this.capturedLatitude = position.coords.latitude;
      this.capturedLongitude = position.coords.longitude;
      this.locationAccuracy = position.coords.accuracy;
      this.isLocationCaptured = true;
      this.locationRetryCount = 0;

      // Update form with location data
      this.appointmentForm.patchValue({
        Latitude: this.capturedLatitude,
        Longitude: this.capturedLongitude,
        LocationAccuracy: this.locationAccuracy
      });

      // Clear validation errors
      this.appointmentForm.controls['Latitude'].setErrors(null);
      this.appointmentForm.controls['Longitude'].setErrors(null);
      this.appointmentForm.controls['Latitude'].updateValueAndValidity();
      this.appointmentForm.controls['Longitude'].updateValueAndValidity();
      this.appointmentForm.controls['Latitude'].markAsTouched();
      this.appointmentForm.controls['Longitude'].markAsTouched();

      // CRITICAL: Update the entire form validity
      this.appointmentForm.updateValueAndValidity();

      console.log('📍 Location captured:', {
        lat: this.capturedLatitude,
        lng: this.capturedLongitude,
        accuracy: this.locationAccuracy
      });

      // Force change detection
      this.cdr.detectChanges();

      return true;

    } catch (error: any) {
      console.error('Location error:', error);
      this.isLocationCaptured = false;

      // Mark location fields as invalid
      this.appointmentForm.controls['Latitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Longitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Latitude'].updateValueAndValidity();
      this.appointmentForm.controls['Longitude'].updateValueAndValidity();

      // CRITICAL: Update the entire form validity
      this.appointmentForm.updateValueAndValidity();

      if (error.code === 1) {
        this.locationError = '⚠️ Location permission is required. Please enable location services.';
        this.appointmentCommonService.CallToster('E', 'Location permission denied. Please enable location services.');

        if (this.locationRetryCount < this.maxLocationRetries) {
          this.locationRetryCount++;
          setTimeout(async () => {
            await this.captureLocationWithPermission();
          }, 3000);
        }
      } else if (error.code === 2) {
        this.locationError = 'Location unavailable. Please try again.';
        this.appointmentCommonService.CallToster('E', 'Location unavailable. Please try again.');
        if (this.locationRetryCount < this.maxLocationRetries) {
          this.locationRetryCount++;
          setTimeout(async () => {
            await this.captureLocationWithPermission();
          }, 2000);
        }
      } else if (error.code === 3) {
        this.locationError = 'Location request timed out. Please try again.';
        this.appointmentCommonService.CallToster('E', 'Location request timed out. Please try again.');
        if (this.locationRetryCount < this.maxLocationRetries) {
          this.locationRetryCount++;
          setTimeout(async () => {
            await this.captureLocationWithPermission();
          }, 2000);
        }
      } else {
        this.locationError = error.message || 'Unable to capture location';
        this.appointmentCommonService.CallToster('E', this.locationError);
      }

      this.cdr.detectChanges();
      return false;
    } finally {
      this.isCapturingLocation = false;
      this.cdr.detectChanges();
    }
  }


  // Method to capture location
  async captureLocation(): Promise<boolean> {
    if (!navigator.geolocation) {
      this.locationError = 'Geolocation is not supported by your browser';
      this.appointmentCommonService.CallToster('E', this.locationError);
      this.isLocationCaptured = false;
      this.appointmentForm.controls['Latitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Longitude'].setErrors({ 'required': true });
      return false;
    }

    this.isCapturingLocation = true;
    this.locationError = '';
    this.isLocationCaptured = false;

    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        );
      });

      this.capturedLatitude = position.coords.latitude;
      this.capturedLongitude = position.coords.longitude;
      this.locationAccuracy = position.coords.accuracy;
      this.isLocationCaptured = true;

      // Update form with location data
      this.appointmentForm.patchValue({
        Latitude: this.capturedLatitude,
        Longitude: this.capturedLongitude,
        LocationAccuracy: this.locationAccuracy
      });

      // Clear validation errors
      this.appointmentForm.controls['Latitude'].setErrors(null);
      this.appointmentForm.controls['Longitude'].setErrors(null);
      this.appointmentForm.controls['Latitude'].updateValueAndValidity();
      this.appointmentForm.controls['Longitude'].updateValueAndValidity();

      console.log('📍 Location captured:', {
        lat: this.capturedLatitude,
        lng: this.capturedLongitude,
        accuracy: this.locationAccuracy
      });

      this.appointmentCommonService.CallToster(
        'S',
        `✅ Location captured! (Accuracy: ${this.locationAccuracy?.toFixed(0)}m)`
      );

      this.cdr.detectChanges();
      return true;

    } catch (error: any) {
      console.error('Location error:', error);
      this.locationError = error.message || 'Unable to capture location';
      this.isLocationCaptured = false;

      // Mark as invalid
      this.appointmentForm.controls['Latitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Longitude'].setErrors({ 'required': true });
      this.appointmentForm.controls['Latitude'].updateValueAndValidity();
      this.appointmentForm.controls['Longitude'].updateValueAndValidity();

      if (error.code === 1) {
        this.appointmentCommonService.CallToster('E', 'Location permission denied. Please enable location services.');
      } else if (error.code === 2) {
        this.appointmentCommonService.CallToster('E', 'Location unavailable. Please try again.');
      } else if (error.code === 3) {
        this.appointmentCommonService.CallToster('E', 'Location request timed out. Please try again.');
      } else {
        this.appointmentCommonService.CallToster('E', this.locationError);
      }

      this.cdr.detectChanges();
      return false;
    } finally {
      this.isCapturingLocation = false;
      this.cdr.detectChanges();
    }
  }
  // Helper method to get IP address
  async getIPAddress(): Promise<string> {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error getting IP:', error);
      return '';
    }
  }

  // Updated submit method with location data
  doSubmitGetAppointment() {
    // Force check login status first
    this.checkLoginStatus();

    // Check if user is logged in
    if (!this.IsLogin) {
      this.openLoginModal();
      return;
    }

    // Check if location is captured - MANDATORY
    if (!this.isLocationCaptured) {
      this.appointmentCommonService.CallToster('E', '⚠️ Location is required to submit this form. Please allow location access.');

      // Try to capture location again
      this.captureLocationWithPermission().then(captured => {
        if (captured) {
          // Force form validation update
          this.cdr.detectChanges();
          // Location captured, try submitting again
          this.doSubmitGetAppointment();
        } else {
          this.appointmentCommonService.CallToster('E', 'Location is required. Please enable location services and try again.');
        }
      });
      return;
    }

    // Check if latitude and longitude are valid
    if (!this.capturedLatitude || !this.capturedLongitude) {
      this.appointmentCommonService.CallToster('E', 'Invalid location data. Please refresh and try again.');
      return;
    }

    // Check if form is valid
    if (this.appointmentForm.invalid) {
      this.appointmentForm.markAllAsTouched();
      // Check specifically for location errors
      if (this.appointmentForm.controls['Latitude'].errors || this.appointmentForm.controls['Longitude'].errors) {
        this.appointmentCommonService.CallToster('E', 'Location is required. Please enable location services.');
        this.captureLocationWithPermission();
        return;
      }
      return;
    }

    this.submitForm();
  }

  private async submitForm() {
    try {
      if (this.appointmentForm.invalid) {
        this.appointmentForm.markAllAsTouched();
        return;
      }

      // For QR and VisitingCard, validate SourceMobile
      if ((this.querySourceType === 'QR' || this.querySourceType === 'VisitingCard') &&
        (!this.querySourceMobile || this.querySourceMobile.length < 10)) {
        this.appointmentCommonService.CallToster('E', 'Please enter a valid 10-digit referrer mobile number');
        return;
      }


      this.isLoader = true;

      let budgetValue = this.appointmentForm.controls['Budget'].value;
      let budgetNumeric = this.parseBudgetToNumber(budgetValue);

      // Store location data before submission (already available)
      const locationData = {
        Latitude: this.capturedLatitude,
        Longitude: this.capturedLongitude,
        LocationAccuracy: this.locationAccuracy
      };

      var data = {
        InteractionType: this.appointmentForm.controls['InteractionType'].value,
        Name: this.appointmentForm.controls['Name'].value,
        Mobile: this.appointmentForm.controls['Mobile'].value,
        Email: this.appointmentForm.controls['Email'].value,
        ReqType: this.appointmentForm.controls['ReqType'].value,
        PropertyType: this.appointmentForm.controls['PropertyType'].value,
        PropertySubType: this.appointmentForm.controls['PropertySubType'].value,
        Area: this.appointmentForm.controls['Area'].value,
        Budget: budgetValue,
        BudgetNumeric: budgetNumeric,
        UserID: this.authUserID,
        Latitude: locationData.Latitude,
        Longitude: locationData.Longitude,
        LocationAccuracy: locationData.LocationAccuracy,
        // Add Source details - ShopID will be determined by SP
        SourceType: this.querySourceType || 'Shop',
        SourceMobile: this.querySourceMobile || null,

        IPAddress: await this.getIPAddress(),
        UserAgent: navigator.userAgent
      };

      this.userAppointmentService.SaveGetAppointment(data).subscribe({
        next: (res: any) => {
          this.appointmentCommonService.CallToster('S', 'Thank you for choosing BuyRentSale.com. One of our representatives will contact you soon');
          this.isLoader = false;

          // Reset form but keep location
          this.appointmentForm.reset({
            InteractionType: 'PostRequirement',
            Name: '',
            Mobile: '',
            Email: '',
            ReqType: '',
            PropertyType: '',
            PropertySubType: '',
            Area: '',
            Budget: '',
            querySourceMobile: ''
          });

          // Restore location data
          this.appointmentForm.patchValue({
            Latitude: locationData.Latitude,
            Longitude: locationData.Longitude,
            LocationAccuracy: locationData.LocationAccuracy
          });

          // Clear validation errors for location
          this.appointmentForm.controls['Latitude'].setErrors(null);
          this.appointmentForm.controls['Longitude'].setErrors(null);
          this.appointmentForm.controls['Latitude'].updateValueAndValidity();
          this.appointmentForm.controls['Longitude'].updateValueAndValidity();
          this.appointmentForm.updateValueAndValidity();

          // ✅ Keep location captured
          // this.isLocationCaptured remains true

          setTimeout(() => {
            $('.close').trigger('click');
            $('.modal').modal('hide');
          }, 1000);
        },
        error: (err: any) => {
          this.isLoader = false;
          this.appointmentCommonService.CallToster('E', 'Error submitting appointment. Please try again.');
        }
      });
    } catch (error) {
      console.error('Error in submitForm:', error);
      this.isLoader = false;
    }
  }

  // Add this method:
  private handleLoginStateChanged(event: Event): void {
    console.log('Login state changed event received');
    this.refreshLoginState();
  }

  // Helper method to detect desktop
  private isDesktopDevice(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone'];
    const isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword));
    return !isMobile;
  }

  private async initCapacitorSpeechRecognition(): Promise<void> {
    try {
      const available = await SpeechRecognition.available();
      this.capacitorSpeechAvailable = available.available;

      if (this.capacitorSpeechAvailable) {
        console.log('Capacitor Speech Recognition available');
        const permissions = await SpeechRecognition.requestPermissions();
        console.log('Speech recognition permissions:', permissions);

        this.speechResultListener = await SpeechRecognition.addListener('partialResults', (result: any) => {
          console.log('Speech partial result:', result);
          if (result && result.matches && result.matches.length > 0 && this.listeningField) {
            const transcript = result.matches[0];
            this.processVoiceInput(this.listeningField, transcript);
            this.listeningField = '';
          }
        });
      } else {
        console.log('Capacitor Speech Recognition not available, falling back to Web API');
        await this.requestMicrophonePermission();
      }
    } catch (error) {
      console.error('Error initializing Capacitor Speech Recognition:', error);
      this.capacitorSpeechAvailable = false;
      await this.requestMicrophonePermission();
    }
  }

  private async startAndroidVoiceRecognition(fieldId: string): Promise<void> {
    if (!this.capacitorSpeechAvailable) {
      this.startWebSpeechRecognition(fieldId);
      return;
    }

    try {
      this.listeningField = fieldId;

      let promptText = '';
      switch (fieldId) {
        case 'Mobile': promptText = 'Speak your 10-digit mobile number'; break;
        case 'Budget': promptText = 'Speak budget (e.g., 25 lakhs, 1.5 crore)'; break;
        case 'Name': promptText = 'Speak your name'; break;
        case 'Area': promptText = 'Speak area name'; break;
      }

      this.appointmentCommonService.CallToster('I', `🎤 ${promptText}`);

      await SpeechRecognition.start({
        language: 'en-IN',
        maxResults: 1,
        prompt: promptText,
        partialResults: true
      });

      setTimeout(async () => {
        try {
          await SpeechRecognition.stop();
          console.log('Speech recognition stopped after timeout');
        } catch (e) {
          console.log('Stop error:', e);
        }
      }, 10000);

    } catch (error: any) {
      console.error('Android voice recognition error:', error);
      this.listeningField = '';

      if (error.message?.includes('not available')) {
        this.appointmentCommonService.CallToster('E', 'Speech recognition not available');
        this.startWebSpeechRecognition(fieldId);
      } else if (error.message?.includes('permission')) {
        this.appointmentCommonService.CallToster('E', 'Microphone permission required');
      } else {
        this.appointmentCommonService.CallToster('E', 'Voice recognition failed. Please try again.');
      }
    }
  }

  private async stopAndroidVoiceRecognition(): Promise<void> {
    try {
      await SpeechRecognition.stop();
    } catch (error) {
      console.error('Error stopping recognition:', error);
    }
  }

  private startWebSpeechRecognition(fieldId: string): void {
    try {
      const SpeechRecognitionAPI = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      if (!SpeechRecognitionAPI) {
        this.appointmentCommonService.CallToster('E', 'Speech recognition not supported');
        return;
      }

      let instructionText = '';
      switch (fieldId) {
        case 'Mobile': instructionText = '📱 Speak your 10-digit mobile number'; break;
        case 'Budget': instructionText = '💰 Speak budget (e.g., 25 lakhs, 1.5 crore)'; break;
        case 'Name': instructionText = '🎤 Speak your name'; break;
        case 'Area': instructionText = '🎤 Speak area name'; break;
      }

      this.appointmentCommonService.CallToster('I', instructionText);

      const recognition = new SpeechRecognitionAPI();
      recognition.continuous = false;
      recognition.interimResults = true;
      recognition.lang = 'en-IN';

      let finalTranscript = '';

      recognition.onstart = () => {
        this.isMobileRecording = true;
      };

      recognition.onresult = (event: any) => {
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          if (event.results[i].isFinal) {
            finalTranscript += event.results[i][0].transcript;
          } else {
            interimTranscript += event.results[i][0].transcript;
          }
        }
        if (interimTranscript) {
          this.updateFieldValue(fieldId, interimTranscript, false);
        }
      };

      recognition.onend = () => {
        this.isMobileRecording = false;
        if (finalTranscript) {
          this.updateFieldValue(fieldId, finalTranscript, true);
          this.appointmentCommonService.CallToster('S', `✅ ${fieldId}: ${finalTranscript}`);
        }
      };

      recognition.onerror = (event: any) => {
        console.error('Speech recognition error:', event.error);
        this.isMobileRecording = false;
        this.appointmentCommonService.CallToster('E', `Voice error: ${event.error}`);
      };

      recognition.start();
    } catch (error) {
      console.error('Web speech recognition error:', error);
      this.isMobileRecording = false;
      this.appointmentCommonService.CallToster('E', 'Error starting voice recognition');
    }
  }

  async startFieldVoice(fieldId: string): Promise<void> {
    if (this.isDesktopBrowser) {
      this.appointmentCommonService.CallToster('I', 'Voice input is only available on mobile devices');
      return;
    }

    if (this.isMobileRecording) {
      this.appointmentCommonService.CallToster('W', 'Recording in progress, please wait');
      return;
    }

    if (this.isAndroidApk) {
      await this.startAndroidVoiceRecognition(fieldId);
      return;
    }

    if (!this.hasMicrophonePermission) {
      const permissionGranted = await this.requestMicrophonePermissionForVoice();
      if (!permissionGranted) {
        return;
      }
    }

    this.startWebSpeechRecognition(fieldId);
  }

  private processVoiceInput(fieldId: string, transcript: string): void {
    switch (fieldId) {
      case 'Name':
        this.appointmentForm.controls['Name'].setValue(this.cleanNameTranscript(transcript));
        break;
      case 'Mobile':
        const digits = transcript.replace(/\D/g, '');
        this.appointmentForm.controls['Mobile'].setValue(digits.substring(0, 10));
        break;
      case 'Area':
        this.appointmentForm.controls['Area'].setValue(this.cleanAreaTranscript(transcript));
        break;
      case 'Budget':
        const budgetValue = this.extractBudgetFromText(transcript);
        this.appointmentForm.controls['Budget'].setValue(budgetValue);
        break;
    }
    this.appointmentCommonService.CallToster('S', `✅ ${fieldId} updated`);
    this.cdr.detectChanges();
  }

  private updateFieldValue(fieldId: string, value: string, isFinal: boolean): void {
    switch (fieldId) {
      case 'Name':
        this.appointmentForm.controls['Name'].setValue(this.cleanNameTranscript(value));
        break;
      case 'Mobile':
        const digits = value.replace(/\D/g, '');
        this.appointmentForm.controls['Mobile'].setValue(digits.substring(0, 10));
        break;
      case 'Area':
        this.appointmentForm.controls['Area'].setValue(this.cleanAreaTranscript(value));
        break;
      case 'Budget':
        if (isFinal) {
          this.appointmentForm.controls['Budget'].setValue(this.extractBudgetFromText(value));
        } else {
          this.appointmentForm.controls['Budget'].setValue(value);
        }
        break;
    }
    this.cdr.detectChanges();
  }

  private async requestMicrophonePermission(): Promise<void> {
    try {
      const permission = await navigator.mediaDevices.getUserMedia({ audio: true });
      permission.getTracks().forEach(track => track.stop());
      this.hasMicrophonePermission = true;
      console.log('Microphone permission granted');
    } catch (error) {
      console.error('Microphone permission denied:', error);
      this.hasMicrophonePermission = false;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupLoginListener();
    }, 100);
  }

  setupLoginListener() {
    if (this.loginModal) {
      console.log('Login modal found, subscribing to loginSuccess');
      if (this.loginSubscription) {
        this.loginSubscription.unsubscribe();
      }

      this.loginSubscription = this.loginModal.loginSuccess.subscribe((event: any) => {
        console.log('Login success event received!', event);
        setTimeout(() => {
          this.onLoginSuccess();
        }, 200);
      });
    } else {
      console.log('Login modal not found, will retry...');
      setTimeout(() => {
        this.setupLoginListener();
      }, 500);
    }
  }

  public triggerLoginUpdate() {
    console.log('Manually triggering login update');
    this.checkLoginStatus();
    this.refreshComponent();
  }

  onLoginSuccess() {
    console.log('Processing login success...');

    setTimeout(() => {
      this.checkLoginStatus();
      this.closeVoiceModal();
      this.refreshComponent();
      this.cdr.detectChanges();
    }, 300);
  }

  private forceLoginCheck(): void {
    this.checkLoginStatus();
    setTimeout(() => this.checkLoginStatus(), 100);
    setTimeout(() => this.checkLoginStatus(), 300);
    setTimeout(() => this.checkLoginStatus(), 500);
    setTimeout(() => this.checkLoginStatus(), 1000);
  }

  private handleStorageChange(event: StorageEvent) {
    console.log('Storage changed:', event.key);
    if (event.key === 'authData' || event.key === 'authProfileData') {
      setTimeout(() => {
        const wasLoggedIn = this.IsLogin;
        this.checkLoginStatus();

        if (!wasLoggedIn && this.IsLogin) {
          console.log('Login detected via storage event!');
          this.onLoginSuccess();
        }
        this.cdr.detectChanges();
      }, 300);
    }
  }

  pollForLoginStatus() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }

    this.pollInterval = setInterval(() => {
      const wasLoggedIn = this.IsLogin;
      this.checkLoginStatus();

      if (!wasLoggedIn && this.IsLogin) {
        console.log('Login detected via polling!');
        this.onLoginSuccess();
        if (this.pollInterval) {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
        }
      }
      this.cdr.detectChanges();
    }, 1000);

    setTimeout(() => {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    }, 300000);
  }

  public refreshLoginState(): void {
    console.log('Manual refresh of login state triggered');
    this.forceLoginCheck();
  }

  buildReverseMap(): void {
    for (const [key, value] of Object.entries(this.homePropertyTypeMap)) {
      this.propertyTypeReverseMap[value.toLowerCase()] = key;
    }
    this.propertyTypeReverseMap['apartment'] = '1--1';
    this.propertyTypeReverseMap['independent house'] = '1--2';
    this.propertyTypeReverseMap['independent'] = '1--2';
    this.propertyTypeReverseMap['villa'] = '1--4';
    this.propertyTypeReverseMap['office'] = '2--7';
    this.propertyTypeReverseMap['office space'] = '2--7';
    this.propertyTypeReverseMap['shop'] = '2--9';
    this.propertyTypeReverseMap['commercial'] = '2';
    this.propertyTypeReverseMap['residential'] = '1';
    this.propertyTypeReverseMap['land'] = '3';
    this.propertyTypeReverseMap['residential land'] = '3--12';
    this.propertyTypeReverseMap['commercial land'] = '3--13';
  }

  ngOnDestroy(): void {
    this.stopMobileRecording();
    if (this.speechResultListener) {
      this.speechResultListener.remove();
    }

    if (this.isAndroidApk) {
      this.stopAndroidVoiceRecognition();
    }

    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }

    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }

    if (this.storageEventHandler) {
      window.removeEventListener('storage', this.storageEventHandler);
      this.storageEventHandler = null;
    }

    if (this.boundHandleLoginStateChanged) {
      window.removeEventListener('loginStateChanged', this.boundHandleLoginStateChanged);
      this.boundHandleLoginStateChanged = null;
    }

    $(document).off('hidden.bs.modal');

    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }

    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }

  checkLoginStatus() {
    const authProfileString = localStorage.getItem('authProfileData');
    const authDataString = localStorage.getItem('authData');

    if (authProfileString && authDataString) {
      try {
        const newAuthProfileData = JSON.parse(authProfileString);
        const authData = JSON.parse(authDataString);

        const profileChanged = JSON.stringify(this.authProfileData) !== JSON.stringify(newAuthProfileData);
        const wasNotLoggedIn = !this.IsLogin;

        this.authProfileData = newAuthProfileData;
        this.authUserID = authData.UserID;
        this.IsLogin = true;

        if (wasNotLoggedIn) {
          this.onLoginSuccess();
        }

      } catch (error) {
        console.error('Error parsing auth data:', error);
        this.IsLogin = false;
        this.authProfileData = null;
        this.authUserID = 0;
      }
    } else {
      this.IsLogin = false;
      this.authProfileData = null;
      this.authUserID = 0;
    }

    this.cdr.detectChanges();
  }

  checkAndShowLoginIfNeeded() {
    if (!this.IsLogin) {
      this.openLoginModal();
    }
  }

  parseBudgetToNumber(budgetStr: string): number {
    if (!budgetStr) return 0;

    let str = budgetStr.toString().toLowerCase().trim();
    str = str.replace(/,/g, '');
    let value = 0;
    const numberMatch = str.match(/(\d+(?:\.\d+)?)/);
    if (!numberMatch) return 0;
    const numericValue = parseFloat(numberMatch[1]);

    if (str.includes('crore') || str.includes('cr') || str.match(/\d+\s*cr/i)) {
      value = numericValue * 10000000;
    }
    else if (str.includes('lakh') || str.includes('lac') || str.includes('lks') ||
      str.match(/\d+\s*l/i) || str.match(/\d+\s*lakhs?/i)) {
      value = numericValue * 100000;
    }
    else if (str.includes('thousand') || str.includes('k') || str.match(/\d+\s*k/i)) {
      value = numericValue * 1000;
    }
    else if (str.length >= 6 && !isNaN(parseFloat(str))) {
      value = numericValue;
    }
    else {
      value = numericValue;
    }
    return Math.round(value);
  }

  formatBudgetForDisplay(budgetNumber: number): string {
    if (!budgetNumber) return '';
    if (budgetNumber >= 10000000) {
      return (budgetNumber / 10000000).toFixed(2) + ' Crore';
    } else if (budgetNumber >= 100000) {
      return (budgetNumber / 100000).toFixed(2) + ' Lakhs';
    } else if (budgetNumber >= 1000) {
      return (budgetNumber / 1000).toFixed(2) + ' Thousand';
    } else {
      return budgetNumber.toString();
    }
  }

  private cleanNameTranscript(transcript: string): string {
    let cleaned = transcript.replace(/[0-9]/g, '');
    cleaned = cleaned.replace(/[^\w\s\u0C00-\u0C7F]/gi, '');
    cleaned = cleaned.trim();
    cleaned = cleaned.replace(/\b\w/g, (char) => char.toUpperCase());
    return cleaned;
  }

  private cleanAreaTranscript(transcript: string): string {
    let cleaned = transcript.replace(/[^\w\s\u0C00-\u0C7F,.-]/gi, '');
    cleaned = cleaned.trim();
    cleaned = cleaned.replace(/\b\w/g, (char) => char.toUpperCase());
    return cleaned;
  }

  private extractSpokenNumbers(transcript: string): string {
    const numberWords: { [key: string]: string } = {
      'zero': '0', 'one': '1', 'two': '2', 'three': '3', 'four': '4',
      'five': '5', 'six': '6', 'seven': '7', 'eight': '8', 'nine': '9',
      'ten': '10', 'eleven': '11', 'twelve': '12', 'thirteen': '13', 'fourteen': '14',
      'fifteen': '15', 'sixteen': '16', 'seventeen': '17', 'eighteen': '18', 'nineteen': '19',
      'twenty': '20', 'thirty': '30', 'forty': '40', 'fifty': '50', 'sixty': '60',
      'seventy': '70', 'eighty': '80', 'ninety': '90'
    };

    const teluguNumbers: { [key: string]: string } = {
      'సున్నా': '0', 'ఒకటి': '1', 'రెండు': '2', 'మూడు': '3', 'నాలుగు': '4',
      'ఐదు': '5', 'ఆరు': '6', 'ఏడు': '7', 'ఎనిమిది': '8', 'తొమ్మిది': '9',
      'పది': '10', 'పదకొండు': '11', 'పన్నెండు': '12', 'పదమూడు': '13', 'పద్నాలుగు': '14',
      'పదిహేను': '15', 'పదహారు': '16', 'పదివేడు': '17', 'పద్దెనిమిది': '18', 'పందొమ్మిది': '19',
      'ఇరవై': '20', 'ముప్పై': '30', 'నలభై': '40', 'యాభై': '50', 'అరవై': '60',
      'డెబ్బై': '70', 'ఎనభై': '80', 'తొంభై': '90'
    };

    let processed = transcript.toLowerCase();

    for (const [word, digit] of Object.entries({ ...numberWords, ...teluguNumbers })) {
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      processed = processed.replace(regex, digit);
    }

    const digits = processed.replace(/\D/g, '');
    return digits;
  }

  setRequestTypeRadio(value: string): void {
    const radioValue = value;

    if (radioValue && ['Buy', 'Sale', 'Rent', 'Projects', 'Service'].includes(radioValue)) {
      this.appointmentForm.controls['ReqType'].setValue(radioValue);
      this.isServiceTabView = radioValue === 'Service';

      const event = { target: { value: radioValue } };
      this.onRequestTypeChange(event);

      setTimeout(() => {
        const radioId = `radio${radioValue}`;
        const radioElement = document.getElementById(radioId) as HTMLInputElement;
        if (radioElement) {
          radioElement.checked = true;
        }
      }, 100);
    }
  }

  setPropertyTypeDropdown(propertyType: string): void {
    const normalizedType = propertyType.toLowerCase().trim();
    let dropdownValue = this.propertyTypeReverseMap[normalizedType];

    if (!dropdownValue) {
      for (const [key, value] of Object.entries(this.propertyTypeReverseMap)) {
        if (normalizedType.includes(key) || key.includes(normalizedType)) {
          dropdownValue = value;
          break;
        }
      }
    }

    if (dropdownValue) {
      if (dropdownValue.includes('--')) {
        const [propertyTypeID, propertySubTypeID] = dropdownValue.split('--');
        this.appointmentForm.controls['PropertyType'].setValue(this.homePropertyTypeMap[propertyTypeID] || '');
        this.appointmentForm.controls['PropertySubType'].setValue(this.homePropertyTypeMap[dropdownValue] || '');
      } else {
        this.appointmentForm.controls['PropertyType'].setValue(this.homePropertyTypeMap[dropdownValue] || propertyType);
        this.appointmentForm.controls['PropertySubType'].setValue('');
      }

      setTimeout(() => {
        const selectElement = document.getElementById('propertyTypeSelect') as HTMLSelectElement;
        if (selectElement) {
          selectElement.value = dropdownValue;
          const changeEvent = new Event('change');
          selectElement.dispatchEvent(changeEvent);
        }
      }, 100);
    } else {
      this.appointmentForm.controls['PropertyType'].setValue(propertyType);
    }
  }

  async openVoiceModal(): Promise<void> {
    if (this.isDesktopBrowser) {
      this.appointmentCommonService.CallToster('I', 'Voice input is only available on mobile devices');
      return;
    }

    if (!this.IsLogin) {
      this.openLoginModal();
      return;
    }

    if (!this.hasMicrophonePermission && !this.isAndroidApk) {
      const permissionGranted = await this.requestMicrophonePermissionForVoice();
      if (!permissionGranted) {
        return;
      }
    }

    this.isVoiceModalOpen = true;
    this.voiceTranscript = '';
    this.isProcessingVoice = false;
    if (this.isMobileRecording) {
      this.stopMobileRecording();
    }
  }

  closeVoiceModal(): void {
    if (this.isMobileRecording) {
      this.stopMobileRecording();
    }
    this.isVoiceModalOpen = false;
    this.voiceTranscript = '';
    this.isProcessingVoice = false;
  }

  onModalBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('voice-modal')) {
      this.closeVoiceModal();
    }
  }

  toggleVoiceRecording(): void {
    if (this.isMobileRecording) {
      this.stopMobileRecording();
    } else {
      this.startMobileRecording();
    }
  }

  private async startMobileRecording(): Promise<void> {
    if (this.isDesktopBrowser) {
      this.appointmentCommonService.CallToster('I', 'Voice input is only available on mobile devices');
      return;
    }

    if (!this.hasMicrophonePermission) {
      const permissionGranted = await this.requestMicrophonePermissionForVoice();
      if (!permissionGranted) {
        return;
      }
    }

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(this.stream);
      this.audioChunks = [];

      this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
        if (event.data.size > 0) {
          this.audioChunks.push(event.data);
        }
      };

      this.mediaRecorder.onstop = async () => {
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
          this.stream = null;
        }

        if (this.audioChunks.length > 0 && !this.isProcessingVoice) {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          this.isProcessingVoice = true;
          this.voiceTranscript = '';
          this.cdr.detectChanges();

          try {
            this.appointmentCommonService.CallToster('I', '🔄 Transcribing...');
            const transcribedText = await this.transcribeWithWhisper(audioBlob);
            const processedText = this.normalizeTeluguTranscription(transcribedText);
            this.voiceTranscript = processedText;
            this.appointmentCommonService.CallToster('S', '✅ Transcription complete!');
          } catch (error: any) {
            console.error('Transcription error:', error);
            this.appointmentCommonService.CallToster('E', 'Error transcribing. Please try again.');
            this.voiceTranscript = 'Error processing audio. Please try again.';
          } finally {
            this.isProcessingVoice = false;
            this.cdr.detectChanges();
          }
        }
        this.isMobileRecording = false;
        this.cdr.detectChanges();
      };

      this.mediaRecorder.start(1000);
      this.isMobileRecording = true;
      this.audioChunks = [];
      this.voiceTranscript = '';
      this.cdr.detectChanges();
      this.appointmentCommonService.CallToster('S', '🎙️ Recording... Speak now');
    } catch (error) {
      console.error('Microphone error:', error);
      this.appointmentCommonService.CallToster('E', 'Could not access microphone. Please check permissions.');
    }
  }

  private stopMobileRecording(): void {
    if (this.mediaRecorder && this.isMobileRecording) {
      this.mediaRecorder.stop();
    }
  }

  private async transcribeWithWhisper(audioBlob: Blob): Promise<string> {
    const groqApiKey = this.groqApiKey || environment.groqApiKey;

    if (!groqApiKey || groqApiKey === 'your-groq-api-key-here') {
      console.warn('Groq API key not configured');
      return "2 BHK apartment in Kukatpally budget 50 lakhs";
    }

    const formData = new FormData();
    formData.append('file', audioBlob, 'recording.webm');
    formData.append('model', 'whisper-large-v3');
    formData.append('language', 'te');
    formData.append('response_format', 'json');
    formData.append('prompt', `Instructions for transcription:
- Convert ALL numbers to English digits (1, 2, 50, 1.5)
- Convert "two" to "2", "three" to "3", etc.
- Keep "BHK" as uppercase English
- Keep "Lakh", "Crore", "Thousand" in English
- Keep property types (Apartment, Villa, Land, Office, Shop) in English
- Keep names and locations in Telugu script
- Output example: "Ramesh garu Kukatpally lo 2 BHK apartment 50 Lakhs"`);

    try {
      const response = await fetch('https://api.groq.com/openai/v1/audio/transcriptions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${groqApiKey}`
        },
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        console.error('Groq API error:', error);
        throw new Error(error.error?.message || 'Transcription failed');
      }

      const data = await response.json();
      let transcript = data.text;
      transcript = this.normalizeTeluguTranscription(transcript);
      transcript = this.ensureEnglishNumbers(transcript);

      return transcript;
    } catch (error) {
      console.error('Groq transcription error:', error);
      this.appointmentCommonService.CallToster('E', 'Transcription failed. Please try again.');
      return "";
    }
  }

  async applyVoiceToForm(): Promise<void> {
    const textToParse = this.voiceTranscript.trim();
    if (!textToParse) {
      this.appointmentCommonService.CallToster('E', 'No text to parse. Please record first.');
      return;
    }

    this.isProcessingVoice = true;
    this.cdr.detectChanges();

    try {
      let extractedData;
      if (this.openAiApiKey && this.openAiApiKey !== 'your-api-key-here') {
        extractedData = await this.extractFieldsWithGPT(textToParse);
      } else {
        extractedData = this.fallbackParsing(textToParse);
      }

      this.fillFormWithData(extractedData);
      this.closeVoiceModal();
      this.appointmentCommonService.CallToster('S', 'Form fields filled! Review and submit.');
    } catch (error: any) {
      console.error('Extraction error:', error);
      this.appointmentCommonService.CallToster('E', `Error parsing text: ${error?.message || 'Unknown error'}`);
    } finally {
      this.isProcessingVoice = false;
      this.cdr.detectChanges();
    }
  }

  private async extractFieldsWithGPT(transcribedText: string): Promise<any> {
    const systemPrompt = `You are an intelligent real estate lead extraction system. Extract information from the user's speech.

INTELLIGENT INTENT DETECTION RULES:
1. Analyze the user's intent carefully:
   - If user wants to PURCHASE/ACQUIRE property → "Buy"
   - If user wants to SELL their property → "Sale" 
   - If user wants to RENT/LEASE property → "Rent"
   - If user is a BUILDER/DEVELOPER with projects → "Projects"
   - If user offers SERVICES (interiors, legal, etc.) → "Service"

2. BUDGET ANALYSIS:
   - Extract budget amount from text (supports formats like: 45 lakhs, 1.5 crore, 45,00,000, 45L, 50K)
   - Convert to standard format (e.g., "45 Lakhs", "1.5 Crore")
   - If budget > 5 Lakhs and intent is ambiguous, suggest "Buy"

3. Convert all text to English for name, area, and requirement fields
4. Extract mobile numbers in English digits ONLY

Return ONLY valid JSON in this exact format:
{
  "name": "English name or empty string",
  "mobile": "10-digit number in English digits or empty string",
  "reqType": "Buy/Sale/Rent/Projects/Service",
  "area": "English area name or empty string",
  "propertyType": "Apartment/Villa/Land/Office/Shop/Independent House",
  "budget": "budget amount with unit (e.g., 45 Lakhs, 1.5 Crore, 50 Thousand) or empty string"
}`;

    try {
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.groqApiKey}`
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [
            { role: 'system', content: systemPrompt },
            { role: 'user', content: transcribedText }
          ],
          temperature: 0.1,
          max_tokens: 400
        })
      });

      if (!response.ok) {
        const error = await response.text();
        console.error('Groq API error:', error);
        return this.fallbackParsing(transcribedText);
      }

      const data = await response.json();
      const resultText = data.choices[0].message.content;
      const jsonMatch = resultText.match(/\{[\s\S]*\}/);

      if (jsonMatch) {
        const parsed = JSON.parse(jsonMatch[0]);
        if (parsed.budget) {
          const budgetNumeric = this.parseBudgetToNumber(parsed.budget);
          if (budgetNumeric > 500000 && (!parsed.reqType || parsed.reqType === 'Sale')) {
            parsed.reqType = 'Buy';
          }
        }
        return parsed;
      }

      return this.fallbackParsing(transcribedText);
    } catch (error) {
      console.error('Groq extraction error:', error);
      return this.fallbackParsing(transcribedText);
    }
  }

  private fallbackParsing(text: string): any {
    const processedText = this.ensureEnglishNumbers(text);
    const lower = processedText.toLowerCase();
    const result: any = {
      name: '',
      mobile: '',
      reqType: '',
      area: '',
      propertyType: '',
      budget: ''
    };

    const mobileMatch = processedText.match(/\b[6-9]\d{9}\b/);
    if (mobileMatch) result.mobile = mobileMatch[0];

    const nameMatch = processedText.match(/^(?:my name is |i am |i'm )?([A-Za-z\u0C00-\u0C7F]+(?:\s+[A-Za-z\u0C00-\u0C7F]+){0,2})/i);
    if (nameMatch) result.name = nameMatch[1];

    const budgetPatterns = [
      /(\d+(?:\.\d+)?)\s*(lakhs?|lacs?|lks?|L)\b/i,
      /(\d+(?:\.\d+)?)\s*(crore|crs?|cr)\b/i,
      /(\d+(?:\.\d+)?)\s*(thousand|k)\b/i,
      /(\d{1,3}(?:,\d{3})*)/,
      /(\d+(?:\.\d+)?)/
    ];

    for (const pattern of budgetPatterns) {
      const match = processedText.match(pattern);
      if (match) {
        let amount = match[1];
        let unit = match[2] ? match[2].toLowerCase() : '';
        amount = amount.replace(/,/g, '');

        if (unit.includes('crore') || unit.includes('cr')) {
          result.budget = `${amount} Crore`;
        } else if (unit.includes('lakh') || unit.includes('lac') || unit.includes('lks') || unit === 'l') {
          result.budget = `${amount} Lakhs`;
        } else if (unit.includes('thousand') || unit === 'k') {
          result.budget = `${amount} Thousand`;
        } else {
          const numAmount = parseFloat(amount);
          if (numAmount >= 100000) {
            result.budget = `${amount} Rupees`;
          } else if (numAmount > 0) {
            result.budget = `${amount} Rupees`;
          }
        }
        break;
      }
    }

    if (lower.includes('want to buy') || lower.includes('looking to buy') || lower.includes('purchase') ||
      lower.includes('buying') || lower.includes('need to buy') || lower.includes('కొనుగోలు')) {
      result.reqType = 'Buy';
    } else if (lower.includes('want to sell') || lower.includes('looking to sell') || lower.includes('selling') ||
      lower.includes('need to sell') || lower.includes('అమ్మకం')) {
      result.reqType = 'Sale';
    } else if (lower.includes('want to rent') || lower.includes('looking for rent') || lower.includes('renting') ||
      lower.includes('need rent') || lower.includes('అద్దె')) {
      result.reqType = 'Rent';
    } else if (lower.includes('project') || lower.includes('development') || lower.includes('builder') ||
      lower.includes('construction') || lower.includes('ప్రాజెక్ట్')) {
      result.reqType = 'Projects';
    } else if (lower.includes('service') || lower.includes('interior') || lower.includes('legal') ||
      lower.includes('maintenance') || lower.includes('సర్వీస్')) {
      result.reqType = 'Service';
    } else {
      if (result.budget) {
        const budgetNum = this.parseBudgetToNumber(result.budget);
        if (budgetNum > 500000) {
          result.reqType = 'Buy';
        }
      }
    }

    const areaPatterns = [
      /(?:in|at|near|around|living in|located in|area of|లో|వద్ద)\s+([A-Za-z\u0C00-\u0C7F\s]+?)(?:\s+(?:need|looking|want|for|budget|కావాలి|$))/i
    ];

    for (const pattern of areaPatterns) {
      const areaMatch = processedText.match(pattern);
      if (areaMatch && areaMatch[1]) {
        result.area = areaMatch[1].trim().substring(0, 50);
        break;
      }
    }

    if (lower.includes('apartment') || lower.includes('flat')) result.propertyType = 'Apartment';
    else if (lower.includes('villa')) result.propertyType = 'Villa';
    else if (lower.includes('land') || lower.includes('plot')) result.propertyType = 'Land';
    else if (lower.includes('office')) result.propertyType = 'Office Space';
    else if (lower.includes('shop')) result.propertyType = 'Shop';
    else if (lower.includes('independent house') || lower.includes('house')) result.propertyType = 'Independent House';

    return result;
  }

  private fillFormWithData(parsedData: any): void {
    if (parsedData.name && parsedData.name.trim()) {
      this.appointmentForm.controls['Name'].setValue(parsedData.name.trim());
    }

    if (parsedData.mobile && parsedData.mobile.trim()) {
      this.appointmentForm.controls['Mobile'].setValue(parsedData.mobile.trim());
    }

    if (parsedData.reqType && parsedData.reqType.trim()) {
      this.setRequestTypeRadio(parsedData.reqType);
    }

    if (parsedData.area && parsedData.area.trim()) {
      this.appointmentForm.controls['Area'].setValue(parsedData.area.trim());
    }

    if (parsedData.propertyType && parsedData.propertyType.trim()) {
      this.setPropertyTypeDropdown(parsedData.propertyType);
    }

    if (parsedData.budget && parsedData.budget.trim()) {
      this.appointmentForm.controls['Budget'].setValue(parsedData.budget.trim());
      const numericValue = this.parseBudgetToNumber(parsedData.budget);
      if (numericValue > 0) {
        console.log(`Budget parsed: ${parsedData.budget} = ₹${numericValue.toLocaleString('en-IN')}`);
      }
    }

    this.cdr.detectChanges();
  }

  onRequestTypeChange(event: any) {
    const selectedValue = event.target.value;
    this.appointmentForm.controls['ReqType'].setValue(selectedValue);
    this.isServiceTabView = selectedValue === 'Service';
    if (this.isServiceTabView) {
      this.CategoryList = [];
      this.SubCategoryList = [];
      this.selectedCategory = '';
      this.categoryServiceType = '';
      this.selectedCatType = 'Service';
      this.LoadBusinessCategoryList();
    }
  }

  onPropertyChange(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue.includes('--')) {
      const [propertyTypeID, propertySubTypeID] = selectedValue.split('--');
      this.appointmentForm.controls['PropertyType'].setValue(this.homePropertyTypeMap[propertyTypeID] || '');
      this.appointmentForm.controls['PropertySubType'].setValue(this.homePropertyTypeMap[selectedValue] || '');
    }
    else {
      this.appointmentForm.controls['PropertyType'].setValue(this.homePropertyTypeMap[selectedValue] || selectedValue);
      this.appointmentForm.controls['PropertySubType'].setValue('');
    }
  }

  LoadBusinessCategoryList() {
    try {
      this.isLoader = true;
      this.appointmentPropertyService.GetAllBusinessCategory().subscribe((res) => {
        this.isLoader = false;
        if (res.status === 1) {
          const fullList = res.body;
          this.CategoryList = fullList.filter((cat: any) =>
            cat.CatType?.toLowerCase() === this.selectedCatType?.toLowerCase()
          );
        }
      }, err => {
        this.isLoader = false;
        this.CategoryList = [];
      });
    } catch (error) {
      this.isLoader = false;
      this.CategoryList = [];
    }
  }

  LoadSubCategory(category: string) {
    try {
      let categoryInfo = category.split('-');
      this.selectedCategory = categoryInfo[0].trim();
      this.categoryServiceType = categoryInfo[1].trim();
      this.isLoader = true;
      this.appointmentForm.controls['PropertyType'].setValue(category);
      this.appointmentPropertyService.GetAllBusinessSubCategory(0, this.selectedCategory).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          this.SubCategoryList = res.body;
        }
      }, err => {
        this.isLoader = false;
        this.SubCategoryList = [];
      });
    } catch (error) {
      this.isLoader = false;
      this.SubCategoryList = [];
    }
  }

  refreshComponent() {
    this.checkLoginStatus();
    this.cdr.detectChanges();
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  private normalizeAllNumbersToEnglish(text: string): string {
    const numberMap: { [key: string]: string } = {
      '౦': '0', '౧': '1', '౨': '2', '౩': '3', '౪': '4',
      '౫': '5', '౬': '6', '౭': '7', '౮': '8', '౯': '9',
      '०': '0', '१': '1', '२': '2', '३': '3', '४': '4',
      '५': '5', '६': '6', '७': '7', '८': '8', '९': '9',
      '௦': '0', '௧': '1', '௨': '2', '௩': '3', '௪': '4',
      '௫': '5', '௬': '6', '௭': '7', '௮': '8', '௯': '9',
      '೦': '0', '೧': '1', '೨': '2', '೩': '3', '೪': '4',
      '೫': '5', '೬': '6', '೭': '7', '೮': '8', '೯': '9',
      '൦': '0', '൧': '1', '൨': '2', '൩': '3', '൪': '4',
      '൫': '5', '൬': '6', '൭': '7', '൮': '8', '൯': '9',
      '০': '0', '১': '1', '২': '2', '৩': '3', '৪': '4',
      '৫': '5', '৬': '6', '৭': '7', '৮': '8', '৯': '9'
    };

    let normalized = text;
    for (const [nativeDigit, englishDigit] of Object.entries(numberMap)) {
      normalized = normalized.replace(new RegExp(nativeDigit, 'g'), englishDigit);
    }
    return normalized;
  }

  private teluguSupported: boolean = true;

  private processBudgetWithTeluguNumbers(transcript: string): string {
    let processed = this.normalizeAllNumbersToEnglish(transcript);

    const currencyTerms: { [key: string]: string } = {
      'లక్ష': 'Lakh', 'లక్షల': 'Lakhs', 'లక్షలు': 'Lakhs',
      'కోటి': 'Crore', 'కోట్ల': 'Crore', 'కోట్లు': 'Crore',
      'వేయి': 'Thousand', 'వేల': 'Thousand', 'వేలు': 'Thousand',
      'லட்சம்': 'Lakhs', 'லட்ச': 'Lakhs',
      'கோடி': 'Crore',
      'ஆயிரம்': 'Thousand',
      'लाख': 'Lakhs', 'लाखों': 'Lakhs',
      'करोड़': 'Crore', 'करोड़ों': 'Crore',
      'हजार': 'Thousand',
      'ಲಕ್ಷ': 'Lakhs', 'ಲಕ್ಷಗಳು': 'Lakhs',
      'ಕೋಟಿ': 'Crore', 'ಕೋಟಿಗಳು': 'Crore',
      'ಸಾವಿರ': 'Thousand'
    };

    for (const [native, english] of Object.entries(currencyTerms)) {
      const regex = new RegExp(native, 'gi');
      processed = processed.replace(regex, english);
    }

    const numbers = processed.match(/\d+(?:\.\d+)?/g);
    if (numbers && numbers.length > 0) {
      const amount = numbers[0];

      if (processed.match(/crore|కోటి|கோடி|करोड़|ಕೋಟಿ/i)) {
        return `${amount} Crore`;
      }
      else if (processed.match(/lakh|లక్ష|லட்சம்|लाख|ಲಕ್ಷ/i)) {
        return `${amount} Lakhs`;
      }
      else if (processed.match(/thousand|వేయి|ஆயிரம்|हजार|ಸಾವಿರ/i)) {
        return `${amount} Thousand`;
      }
      else {
        return amount;
      }
    }

    return processed;
  }

  private ensureEnglishNumbers(text: string): string {
    let processed = this.normalizeAllNumbersToEnglish(text);

    const numberWords: { [key: string]: string } = {
      'zero': '0', 'one': '1', 'two': '2', 'three': '3', 'four': '4',
      'five': '5', 'six': '6', 'seven': '7', 'eight': '8', 'nine': '9',
      'ten': '10', 'eleven': '11', 'twelve': '12', 'thirteen': '13', 'fourteen': '14',
      'fifteen': '15', 'sixteen': '16', 'seventeen': '17', 'eighteen': '18', 'nineteen': '19',
      'twenty': '20', 'thirty': '30', 'forty': '40', 'fifty': '50', 'sixty': '60',
      'seventy': '70', 'eighty': '80', 'ninety': '90',
      'సున్నా': '0', 'ఒకటి': '1', 'రెండు': '2', 'మూడు': '3', 'నాలుగు': '4',
      'ఐదు': '5', 'ఆరు': '6', 'ఏడు': '7', 'ఎనిమిది': '8', 'తొమ్మిది': '9',
      'పది': '10', 'పదకొండు': '11', 'పన్నెండు': '12', 'పదమూడు': '13', 'పద్నాలుగు': '14',
      'పదిహేను': '15', 'పదహారు': '16', 'పదివేడు': '17', 'పద్దెనిమిది': '18', 'పందొమ్మిది': '19',
      'ఇరవై': '20', 'ముప్పై': '30', 'నలభై': '40', 'యాభై': '50', 'అరవై': '60',
      'డెబ్బై': '70', 'ఎనభై': '80', 'తొంభై': '90',
      'शून्य': '0', 'एक': '1', 'दो': '2', 'तीन': '3', 'चार': '4',
      'पांच': '5', 'छह': '6', 'सात': '7', 'आठ': '8', 'नौ': '9'
    };

    const words = processed.split(/(\s+)/);
    for (let i = 0; i < words.length; i++) {
      const word = words[i].toLowerCase().trim();
      if (numberWords[word]) {
        words[i] = numberWords[word];
      }
    }
    processed = words.join('');

    return processed;
  }

  private startAndroidFieldVoice(fieldId: string): void {
    this.startWebSpeechRecognition(fieldId);
  }

  private initializeAndStartVoice(fieldId: string): void {
    if (!this.speechRecognitionInitialized) {
      this.speechRecognitionInitialized = true;
      this.initSpeechRecognition();
    }

    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) {
      this.appointmentCommonService.CallToster('E', 'Voice is not supported in this browser.');
      return;
    }

    this.startRecognitionWithLanguage(fieldId);
  }

  private startRecognitionWithLanguage(fieldId: string, retryCount: number = 0): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) return;

    const fieldRec = new SpeechRecognition();
    fieldRec.continuous = false;
    fieldRec.interimResults = true;
    fieldRec.maxAlternatives = 3;
    fieldRec.lang = 'en-IN';

    const btn = (event as any)?.target as HTMLElement;
    const originalText = btn?.innerHTML || '🎤';
    let finalTranscript = '';
    let hasHindiChars = false;

    fieldRec.onstart = () => {
      if (btn) btn.innerHTML = '⏺';
    };

    fieldRec.onresult = (event: any) => {
      for (let i = event.resultIndex; i < event.results.length; i++) {
        let transcript = event.results[i][0].transcript;
        hasHindiChars = /[\u0900-\u097F]/.test(transcript);
        transcript = this.normalizeAllNumbersToEnglish(transcript);

        if (hasHindiChars && fieldId !== 'Budget') {
          transcript = this.transliterateHindiToEnglish(transcript);
        }

        if (event.results[i].isFinal) {
          if (fieldId === 'Name') {
            let nameValue = this.cleanNameTranscript(transcript);
            this.appointmentForm.controls['Name'].setValue(nameValue);
          } else if (fieldId === 'Mobile') {
            const digits = transcript.replace(/\D/g, '');
            let mobileNumber = digits.substring(0, 10);
            if (mobileNumber.length === 10) {
              this.appointmentForm.controls['Mobile'].setValue(mobileNumber);
            } else if (digits.length > 0) {
              this.appointmentForm.controls['Mobile'].setValue(digits);
            }
          } else if (fieldId === 'Area') {
            let areaValue = this.cleanAreaTranscript(transcript);
            this.appointmentForm.controls['Area'].setValue(areaValue);
          } else if (fieldId === 'Budget') {
            let processedBudget = this.extractBudgetFromText(transcript);
            this.appointmentForm.controls['Budget'].setValue(processedBudget);
            const numericValue = this.parseBudgetToNumber(processedBudget);
            if (numericValue > 0) {
              const formatted = this.formatBudgetForDisplay(numericValue);
              this.appointmentCommonService.CallToster('S', `Budget: ${processedBudget} = ₹${numericValue.toLocaleString('en-IN')} (${formatted})`);
            }
          }
          this.cdr.detectChanges();
        } else {
          if (fieldId === 'Name') {
            this.appointmentForm.controls['Name'].setValue(this.cleanNameTranscript(transcript));
          } else if (fieldId === 'Area') {
            this.appointmentForm.controls['Area'].setValue(this.cleanAreaTranscript(transcript));
          } else if (fieldId === 'Mobile') {
            const digits = transcript.replace(/\D/g, '');
            this.appointmentForm.controls['Mobile'].setValue(digits.substring(0, 10));
          }
          this.cdr.detectChanges();
        }
      }
    };

    fieldRec.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      let errorMsg = 'Voice error occurred. ';

      if (event.error === 'no-speech') {
        errorMsg += 'No speech detected. Please try again.';
      } else if (event.error === 'audio-capture') {
        errorMsg += 'No microphone found.';
      } else if (event.error === 'not-allowed') {
        errorMsg += 'Microphone permission denied.';
      } else {
        errorMsg += 'Please try again.';
      }

      this.appointmentCommonService.CallToster('E', errorMsg);
      if (btn) btn.innerHTML = originalText;
      this.cdr.detectChanges();
    };

    fieldRec.onend = () => {
      if (btn) btn.innerHTML = originalText;
      this.cdr.detectChanges();
    };

    try {
      fieldRec.start();
    } catch (error) {
      console.error('Failed to start speech recognition:', error);
      this.appointmentCommonService.CallToster('E', 'Could not start voice recognition. Please refresh and try again.');
      if (btn) btn.innerHTML = originalText;
    }
  }

  private transliterateHindiToEnglish(text: string): string {
    const hindiMap: { [key: string]: string } = {
      'क': 'ka', 'ख': 'kha', 'ग': 'ga', 'घ': 'gha', 'ङ': 'nga',
      'च': 'cha', 'छ': 'chha', 'ज': 'ja', 'झ': 'jha', 'ञ': 'nya',
      'ट': 'ta', 'ठ': 'tha', 'ड': 'da', 'ढ': 'dha', 'ण': 'na',
      'त': 'ta', 'थ': 'tha', 'द': 'da', 'ध': 'dha', 'न': 'na',
      'प': 'pa', 'फ': 'pha', 'ब': 'ba', 'भ': 'bha', 'म': 'ma',
      'य': 'ya', 'र': 'ra', 'ल': 'la', 'व': 'va', 'श': 'sha',
      'ष': 'sha', 'स': 'sa', 'ह': 'ha',
      'अ': 'a', 'आ': 'aa', 'इ': 'i', 'ई': 'ee', 'उ': 'u',
      'ऊ': 'oo', 'ऋ': 'ri', 'ए': 'e', 'ऐ': 'ai', 'ओ': 'o', 'औ': 'au',
      'ं': 'n', 'ः': 'h', '़': '', '्': '',
      'ा': 'a', 'ि': 'i', 'ी': 'ee', 'ु': 'u', 'ू': 'oo',
      'ृ': 'ri', 'े': 'e', 'ै': 'ai', 'ो': 'o', 'ौ': 'au'
    };

    let converted = text;
    for (const [hindi, english] of Object.entries(hindiMap)) {
      converted = converted.replace(new RegExp(hindi, 'g'), english);
    }

    return converted;
  }

  private extractBudgetFromText(text: string): string {
    let processed = text.toLowerCase();

    const patterns = [
      { pattern: /(\d+(?:\.\d+)?)\s*(?:crore|crs?|cr|करोड़|కోటి)/i, unit: 'Crore' },
      { pattern: /(\d+(?:\.\d+)?)\s*(?:lakh|lacs?|l|लाख|లక్ష)/i, unit: 'Lakhs' },
      { pattern: /(\d+(?:\.\d+)?)\s*(?:thousand|k|हजार|వేయి)/i, unit: 'Thousand' },
      { pattern: /(\d+(?:\.\d+)?)/, unit: '' }
    ];

    for (const { pattern, unit } of patterns) {
      const match = processed.match(pattern);
      if (match) {
        const amount = match[1];
        if (unit) {
          return `${amount} ${unit}`;
        }
        return amount;
      }
    }

    return text;
  }

  private initSpeechRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.speechRecognitionAvailable = true;
    }
  }

  private normalizeTeluguTranscription(text: string): string {
    if (!text) return text;

    let result = text;

    const teluguDigits: { [key: string]: string } = {
      '౦': '0', '౧': '1', '౨': '2', '౩': '3', '౪': '4',
      '౫': '5', '౬': '6', '౭': '7', '౮': '8', '౯': '9'
    };
    for (const [telugu, english] of Object.entries(teluguDigits)) {
      result = result.replace(new RegExp(telugu, 'g'), english);
    }

    const teluguNumbers: { [key: string]: string } = {
      'సున్నా': '0', 'ఒకటి': '1', 'రెండు': '2', 'మూడు': '3', 'నాలుగు': '4',
      'ఐదు': '5', 'ఆరు': '6', 'ఏడు': '7', 'ఎనిమిది': '8', 'తొమ్మిది': '9',
      'పది': '10', 'పదకొండు': '11', 'పన్నెండు': '12', 'పదమూడు': '13', 'పద్నాలుగు': '14',
      'పదిహేను': '15', 'పదహారు': '16', 'పదివేడు': '17', 'పద్దెనిమిది': '18', 'పందొమ్మిది': '19',
      'ఇరవై': '20', 'ముప్పై': '30', 'నలభై': '40', 'యాభై': '50',
      'అరవై': '60', 'డెబ్బై': '70', 'ఎనభై': '80', 'తొంభై': '90'
    };
    for (const [telugu, english] of Object.entries(teluguNumbers)) {
      result = result.replace(new RegExp(telugu, 'gi'), english);
    }

    const teluguToEnglish: { [key: string]: string } = {
      'టూ': '2', 'త్రీ': '3', 'ఫోర్': '4', 'ఫైవ్': '5',
      'సిక్స్': '6', 'సెవెన్': '7', 'ఎయిట్': '8', 'నైన్': '9',
      'టెన్': '10', 'బేచ': 'BHK', 'బెడ్రూమ్': 'BHK',
      'అపార్ట్మెంట్': 'Apartment', 'విల్లా': 'Villa',
      'ల్యాండ్': 'Land', 'హౌస్': 'House',
      'ఆఫీస్': 'Office', 'షాప్': 'Shop',
      'లక్ష': 'Lakh', 'లక్షల': 'Lakhs',
      'కోటి': 'Crore', 'కోట్ల': 'Crore',
      'వేయి': 'Thousand', 'వేల': 'Thousand'
    };
    for (const [telugu, english] of Object.entries(teluguToEnglish)) {
      result = result.replace(new RegExp(telugu, 'gi'), english);
    }

    result = result.replace(/(\d+)\s*BHK/gi, '$1 BHK');
    result = result.replace(/(\d+)\s*Lakhs?/gi, '$1 Lakhs');
    result = result.replace(/(\d+)\s*Crore/gi, '$1 Crore');
    result = result.replace(/[^\x00-\x7F\u0C00-\u0C7F]/g, ' ');
    result = result.replace(/\s+/g, ' ').trim();

    return result;
  }

  resetFormForNewRequest(): void {
    this.appointmentForm.reset({
      InteractionType: 'PostRequirement',
      Name: '',
      Mobile: '',
      Email: '',
      ReqType: '',
      PropertyType: '',
      PropertySubType: '',
      Area: '',
      Budget: ''
    });

    this.isServiceTabView = false;
    this.selectedCategory = '';
    this.categoryServiceType = '';
    this.selectedCatType = '';
    this.CategoryList = [];
    this.SubCategoryList = [];
    this.voiceTranscript = '';

    // Reset SourceMobile - Clear the value
    this.querySourceMobile = '';

    // Direct DOM manipulation to clear the input
    if (this.sourceMobileInputRef) {
      this.sourceMobileInputRef.nativeElement.value = '';
    }

    // Force change detection to update the input
    this.cdr.detectChanges();

    setTimeout(() => {
      const radioButtons = document.querySelectorAll('input[type="radio"]');
      radioButtons.forEach((radio: any) => {
        radio.checked = false;
      });

      const propertySelect = document.getElementById('propertyTypeSelect') as HTMLSelectElement;
      if (propertySelect) {
        propertySelect.value = '';
      }

      Object.keys(this.appointmentForm.controls).forEach(key => {
        this.appointmentForm.controls[key].markAsUntouched();
        this.appointmentForm.controls[key].markAsPristine();
      });

      // Additional force update for the source mobile input
      const sourceMobileInput = document.getElementById('sourceMobileInput') as HTMLInputElement;
      if (sourceMobileInput) {
        sourceMobileInput.value = '';
      }

      this.cdr.detectChanges();
    }, 100);
  }

  openLoginModal() {
    this.resetFormForNewRequest();

    if (this.loginModal) {
      if (!this.loginSubscription) {
        this.setupLoginListener();
      }
      this.loginModal.openModal();
    } else {
      console.log('Login modal not available, using fallback');
      const modalElement = document.querySelector('app-login-modal');
      if (modalElement && (modalElement as any).openModal) {
        (modalElement as any).openModal();

        try {
          const component = (modalElement as any).__ngContext__;
          if (component && component.loginSuccess) {
            if (this.loginSubscription) {
              this.loginSubscription.unsubscribe();
            }
            this.loginSubscription = component.loginSuccess.subscribe((event: any) => {
              this.onLoginSuccess();
            });
          }
        } catch (e) {
          console.log('Could not subscribe to modal event, using polling');
          this.pollForLoginStatus();
        }
      } else {
        this.pollForLoginStatus();
      }
    }
  }

  setupModalCloseListener() {
    $(document).on('hidden.bs.modal', '.modal', () => {
      console.log('Modal closed, resetting form');
      this.resetFormForNewRequest();
    });
  }

  private async checkSpeechRecognitionAvailability(): Promise<void> {
    try {
      const SpeechRecognitionAPI = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      this.speechRecognitionAvailable = !!SpeechRecognitionAPI;

      if (this.speechRecognitionAvailable && this.isMobileApp) {
        console.log('Speech recognition available on mobile');
      }
    } catch (error) {
      console.error('Error checking speech recognition:', error);
      this.speechRecognitionAvailable = false;
    }
  }

  private async requestMicrophonePermissionForVoice(): Promise<boolean> {
    if (this.microphonePermissionRequested) {
      return this.hasMicrophonePermission;
    }

    try {
      const permission = await navigator.mediaDevices.getUserMedia({ audio: true });
      permission.getTracks().forEach(track => track.stop());
      this.hasMicrophonePermission = true;
      this.microphonePermissionRequested = true;
      console.log('Microphone permission granted');
      return true;
    } catch (error) {
      console.error('Microphone permission denied:', error);
      this.hasMicrophonePermission = false;
      this.appointmentCommonService.CallToster('E', 'Microphone permission is required for voice input. Please allow microphone access.');
      return false;
    }
  }

  private handleVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      // User returned to the page - check if location is still needed
      if (!this.isLocationCaptured && this.IsLogin) {
        console.log('User returned to page, re-checking location...');
        // Check if location was enabled while away
        this.captureLocationWithPermission().then(() => {
          // Force form validation after location capture attempt
          this.appointmentForm.updateValueAndValidity();
          this.cdr.detectChanges();
        });
      } else if (this.isLocationCaptured) {
        // If location is already captured, just update form validation
        this.checkLocationStatusAndUpdate();
      }
    }
  }


  // Add this method to check location status and update form
  checkLocationStatusAndUpdate(): void {
    // Check if location is already captured
    if (this.isLocationCaptured && this.capturedLatitude && this.capturedLongitude) {
      // Update form with location data
      this.appointmentForm.patchValue({
        Latitude: this.capturedLatitude,
        Longitude: this.capturedLongitude,
        LocationAccuracy: this.locationAccuracy
      });

      // Clear validation errors
      this.appointmentForm.controls['Latitude'].setErrors(null);
      this.appointmentForm.controls['Longitude'].setErrors(null);
      this.appointmentForm.controls['Latitude'].updateValueAndValidity();
      this.appointmentForm.controls['Longitude'].updateValueAndValidity();
      this.appointmentForm.updateValueAndValidity();
      this.cdr.detectChanges();
    }
  }


}